<template>
  <div class="position-relative d-flex">
    <!-- 문서 리스트 -->
    <div class="w-100">
      <b-row
        v-for="(doc, index) in disclosure_group.documents"
        :key="index"
        class="document-item py-3 border-bottom"
      >
        <b-col ols="12" sm="8" xl="9" class="d-flex align-items-center">
          <h5
            class="fw-600 mb-0 text-left gray-850"
            :style="{
              borderLeft: '4px solid ' + selected_report.main_color,
              paddingLeft: '10px'
            }"
            @click="
              doc.description != null &&
                doc.description !== 'null' &&
                doc.description !== 'undefined' &&
                selectDoc(index)
            "
          >
            {{ lang === 'KOR' ? doc.title : doc.translated?.title_e || doc.title }}
          </h5>
        </b-col>

        <b-col
          cols="12"
          sm="4"
          xl="3"
          class="d-flex justify-content-start justify-content-sm-end align-items-start"
        >
          <b-button
            class="btn-skep py-3 mt-3 mt-sm-0"
            @click.prevent="
              getDocPath(doc) && downloadFile(doc.title, $store.state.static_host + getDocPath(doc))
            "
          >
            <a
              class="custom-attach-businesscase"
              :href="print_mode ? $store.state.static_host + getDocPath(doc) : '#'"
              target="_blank"
            >
              {{ lang === 'KOR' ? '다운로드' : 'Download' }}
              <b-icon icon="download" />
            </a>
          </b-button>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import { downloadFile } from '@/components/util.js';
import { mapState, mapGetters } from 'vuex';

export default {
  name: 'DocumentSetSb',
  props: {
    disclosure_group: {
      type: Object,
      required: true
    },
    print_mode: {
      type: Boolean,
      required: false
    }
  },
  data() {
    return {
      selectedDocIndex: null
    };
  },
  computed: {
    ...mapGetters('report_list', ['selected_report']),
    ...mapState('report_list', ['lang'])
  },
  methods: {
    downloadFile,
    getDocPath(doc) {
      if (this.lang === 'ENG' && doc.translated?.path) {
        return doc.translated.path;
      }
      return doc.path;
    },
    selectDoc(index) {
      // 이미 선택된 인덱스면 null로, 아니면 해당 인덱스로 토글
      this.selectedDocIndex = this.selectedDocIndex === index ? null : index;
    }
  }
};
</script>

<style scoped>
.title-wrap {
  white-space: normal;
  word-wrap: break-word;
  word-break: break-word;
}

/* h5 호버 효과 */
.document-item h5:hover {
  background-color: #f5f5f5;
  cursor: pointer;
}

/* 각 아이템을 기준으로 절대 배치되도록 */
.document-item {
  position: relative;
}

/* 설명 박스 */
.doc-desc {
  position: absolute;
  top: 105%;
  /* 제목/아이템 바로 아래 */
  left: 0;
  width: 100%;
  background: #fff;
  padding: 16px;
  border: 1px solid #ccc;
  border-radius: 12px;
  z-index: 10;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.custom-attach-businesscase {
  color: inherit;
}

.custom-attach-businesscase:focus,
.custom-attach-businesscase:active,
.custom-attach-businesscase:focus-visible {
  outline: none !important;
  box-shadow: none !important;
}
</style>
